export default __webpack_public_path__ + "static/media/whitney.a5abc7bb.jpg";